import React from 'react'
import { Icon, SemanticCOLORS } from 'semantic-ui-react'
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon'

interface Props {
  isLoading: boolean;
  top?: string;
  right?: string;
  size?: IconSizeProp;
  color?: SemanticCOLORS | undefined;
}

const _LoadingComponent: React.FC<Props> = ({ isLoading, top, right, size, color }) => {
  if (isLoading) {
    return (
      <div style={{ position: 'fixed', top: top ? top : '40%', right: right ? right : '50%', zIndex: 9999 }}>
        <Icon name='circle notch' size={size ? size : 'massive'} color={color} opacity={0.5} spin />
      </div>
    )
  }
  return null
}

export const LoadingComponent = React.memo(_LoadingComponent)
